import { Article } from 'article/article';
import { ArticleOutput } from 'article/model/article.output';

export abstract class ArticleConverterPort {
	public abstract articleAsEntity(article: ArticleOutput): Article;

	public abstract articlesAsEntities(outputs: ArticleOutput[]): Article[];
}
